import api from "@/lib/api";
import { ParcoursId } from "@/lib/constants";
import { ENDPOINTS } from "@/lib/endpoints";
import { recaptchaService } from "./captcha.service";
import { withRateLimit, generateClientIdentifier } from "@/lib/rateLimiter";
import { logger } from "@/lib/logger";

export const fetchChatPrediction = async (
  question: string,
  userType: ParcoursId,
  useremail: string = "tester@example.com"
): Promise<Response> => {
  const clientId = generateClientIdentifier();
  
  return withRateLimit(async () => {
    // Générer le token reCAPTCHA avec fallback automatique v3 → v2
    const { token: captchaToken, version } = await recaptchaService.generateTokenWithFallback('chat_message');
    
    logger.debug("Envoi de requête chat", { 
      userType, 
      messageLength: question.length,
      clientId 
    }, 'ChatService');
    
    return api.post(ENDPOINTS.chat.stream, {
      useremail,
      message: question,
      user_type: userType,
    }, {
      headers: {
        "Content-Type": "application/json",
        Accept: "text/event-stream",
        "X-Captcha-Token": captchaToken,
        "X-Captcha-Version": version,
        "X-Client-ID": clientId,
      },
    });
  }, clientId);
};

export const deleteAllHistory = async (
  useremail: string = "tester@example.com"
): Promise<Response> => {
  // Générer le token reCAPTCHA avec fallback automatique v3 → v2
  const { token: captchaToken, version } = await recaptchaService.generateTokenWithFallback('chat_message');
  
  return api.post(ENDPOINTS.chat.stream, {
    useremail,
    message: "delete_all_history",
  }, {
    headers: {
      "Content-Type": "application/json",
      Accept: "text/event-stream",
      "X-Captcha-Token": captchaToken,
      "X-Captcha-Version": version,
    },
  });
};
